var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4101 8.68698C19.1101 7.92413 18.3958 7.34984 17.3986 7.06985C16.5072 6.82128 15.5129 6.85556 14.7329 7.15842L11.9529 8.24699L6.77576 4.96414C6.71577 4.92413 6.64148 4.90985 6.57291 4.92413L5.21577 5.16414C5.11862 5.18128 5.03577 5.24985 4.99863 5.34128C4.96434 5.43557 4.97862 5.53843 5.03863 5.61842L8.16149 9.72985L3.71863 11.467L2.14434 9.88413C2.09006 9.82984 2.01005 9.79556 1.93862 9.79842L0.85291 9.8127C0.758619 9.8127 0.672909 9.85842 0.621482 9.93841C0.567196 10.0156 0.555773 10.1127 0.590058 10.2013L2.11576 14.1041C2.35291 14.7098 2.93576 15.0813 3.55005 15.0813C3.73577 15.0813 3.92434 15.047 4.11006 14.9756L19.2472 9.05843C19.3929 8.99842 19.4672 8.8327 19.4101 8.68698Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneList);
export default __webpack_public_path__ + "static/media/PlaneList.5ed68549f3cf8bbf548c8815fa27cbb2.svg";
export { ForwardRef as ReactComponent };